import { WIDGET_NAME } from '@sitegen/common/constants';

export const trackingFlowSubTypes = {
    [WIDGET_NAME.CF_REDEEM]: 'code-first',
    [WIDGET_NAME.ULC_REDEEM]: 'platform-first',
    [WIDGET_NAME.PYC_REDEEM]: 'pick your own content',
};
